import { Fragment } from '@wordpress/element';
import { __ } from '@wordpress/i18n';
import { addFilter } from '@wordpress/hooks';
import { MergeFieldset } from './merge-fields';

function Modal( content, clientId, action, updateSettings ) {
	const fields = [
		{
			label: 'Name',
			name: 'name',
			help: __( 'The sender name.', 'popper' ),
		},
		{
			label: 'From',
			name: 'from',
			help: __( 'The sender email.', 'popper' ),
		},
		{
			label: 'To',
			name: 'to',
			help: __(
				'The email where this form will be sent. If empty will be set to WP admin email.',
				'popper'
			),
		},
		{
			label: 'Subject',
			name: 'subject',
			help: __( 'The email subject.', 'popper' ),
		},
		{
			label: 'Message',
			name: 'message',
			help: __( 'The email message.', 'popper' ),
		},
	];

	return (
		<Fragment>
			<p>{ __( 'Map the fields below to form fields.' ) }</p>
			<MergeFieldset
				action={ action }
				clientId={ clientId }
				fields={ fields }
				updateSettings={ updateSettings }
			/>
		</Fragment>
	);
}

addFilter( 'popper.modal.Email', 'popper/email', Modal, 3 );
